export default __webpack_public_path__ + "static/media/polar.39a41dc3.png";